import { isGuest } from '../utils/role'
import { getParamFrom } from '../utils/common'

export const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "account-login" */ '../views/TheAccountLogin.vue'),
    meta: {
      layout: 'Guest',
      middleware: ({ role, next }) => isGuest(role) ? next() : next('/')
    }
  },

  {
    path: '/login/:token',
    name: 'loginWithToken',
    component: () => import(/* webpackChunkName: "account-login" */ '../views/TheAccountLogin.vue'),
    meta: {
      layout: 'Guest',
      middleware: ({ role, next }) => isGuest(role) ? next() : next('/')
    }
  },

  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "account-register" */ '../views/TheAccountRegister.vue'),
    meta: {
      layout: 'Guest',
      middleware: ({ role, vendor, next }) => {
        if (isGuest(role)) {
          if (!vendor?.branding?.self_registration_enabled) {
            return next('/login')
          }

          return next()
        }

        return next('/')
      }
    }
  },

  {
    path: '/reset',
    name: 'reset',
    component: () => import(/* webpackChunkName: "account-reset" */ '../views/TheAccountReset.vue'),
    meta: {
      layout: 'Guest',
      middleware: ({ role, next }) => isGuest(role) ? next() : next('/')
    }
  },

  {
    path: '/',
    redirect: '/sessions'
  },

  {
    path: '/sessions',
    name: 'sessions',
    component: () => import(/* webpackChunkName: "sessions" */ '../views/TheSessions.vue'),
    meta: {
      layout: 'Main',
      middleware: ({ role, next }) => !isGuest(role) ? next() : next(`/login${getParamFrom()}`)
    }
  },

  {
    path: '/sessions/:sessionID',
    name: 'session',
    component: () => import(/* webpackChunkName: "session" */ '../views/TheSession.vue'),
    meta: {
      layout: 'Main',
      middleware: ({ role, next }) => !isGuest(role) ? next() : next(`/login${getParamFrom()}`)
    }
  },

  {
    path: '/sessions/:sessionID/steps/:stepID',
    name: 'training',
    component: () => import(/* webpackChunkName: "training" */ '../views/TheTraining.vue'),
    meta: {
      layout: 'Main',
      middleware: ({ role, next }) => !isGuest(role) ? next() : next(`/login${getParamFrom()}`)
    }
  },

  {
    path: '/messages',
    name: 'messenger',
    props: true,
    component: () => import(/* webpackChunkName: "messenger" */ '../views/TheMessenger.vue'),
    meta: {
      layout: 'Main',
      middleware: ({ role, next }) => !isGuest(role) ? next() : next(`/login${getParamFrom()}`)
    }
  },

  {
    path: '/marks',
    name: 'marks',
    component: () => import(/* webpackChunkName: "marks" */ '../views/TheMarks.vue'),
    meta: {
      layout: 'Main',
      middleware: ({ role, next }) => !isGuest(role) ? next() : next(`/login${getParamFrom()}`)
    }
  },

  {
    path: '/history',
    name: 'history',
    component: () => import(/* webpackChunkName: "history" */ '../views/TheHistory.vue'),
    meta: {
      layout: 'Main',
      middleware: ({ role, next }) => !isGuest(role) ? next() : next(`/login${getParamFrom()}`)
    }
  },

  {
    path: '/meetings',
    name: 'meetings',
    component: () => import(/* webpackChunkName: "meetings" */ '../views/TheMeetings.vue'),
    meta: {
      layout: 'Main',
      middleware: ({ role, next }) => !isGuest(role) ? next() : next(`/login${getParamFrom()}`)
    }
  },

  {
    path: '/meetings/:meetingID',
    name: 'meeting',
    component: () => import(/* webpackChunkName: "meeting" */ '../views/TheMeeting.vue'),
    meta: {
      layout: 'Main',
      middleware: ({ role, next }) => !isGuest(role) ? next() : next(`/login${getParamFrom()}`)
    }
  },

  {
    path: '/groups',
    name: 'groups',
    component: () => import(/* webpackChunkName: "groups" */ '../views/TheGroups.vue'),
    meta: {
      layout: 'Main',
      middleware: ({ role, next }) => !isGuest(role) ? next() : next(`/login${getParamFrom()}`)
    }
  },

  {
    path: '/surveys',
    name: 'surveys',
    component: () => import(/* webpackChunkName: "groups" */ '../views/TheSurveys.vue'),
    meta: {
      layout: 'Main',
      middleware: ({ role, next }) => !isGuest(role) ? next() : next(`/login${getParamFrom()}`)
    }
  },

  {
    path: '/surveys/:surveyID',
    name: 'survey',
    component: () => import(/* webpackChunkName: "groups" */ '../views/TheSurvey.vue'),
    meta: {
      layout: 'Main',
      middleware: ({ role, next }) => !isGuest(role) ? next() : next(`/login${getParamFrom()}`)
    }
  },

  {
    path: '/users/:userID',
    name: 'user',
    component: () => import(/* webpackChunkName: "user" */ '../views/TheUser.vue'),
    meta: {
      layout: 'Main',
      middleware: ({ role, next }) => !isGuest(role) ? next() : next(`/login${getParamFrom()}`)
    }
  },

  {
    path: '/users/:userID/edit',
    name: 'user-edit',
    component: () => import(/* webpackChunkName: "user-edit" */ '../views/TheUserEdit.vue'),
    meta: {
      layout: 'Main',
      middleware: ({ role, next }) => !isGuest(role) ? next() : next(`/login${getParamFrom()}`)
    }
  },

  {
    path: '*',
    name: 'error',
    component: () => import(/* webpackChunkName: "error-page" */ '../views/TheErrorPage.vue'),
    meta: {
      layout: 'Empty'
    }
  }
]
